import { EventEmitter } from '@angular/core';
import { GenericListMenuHandlerData } from './generic-list-menu-handler-data';

export class GenericListMenuDefinition {
  data: any;
  value: any;
  choices: Array<any>;
  clickHandler: EventEmitter<GenericListMenuHandlerData>;
  disabled = false;

  constructor(data: any, clickHandler: EventEmitter<GenericListMenuHandlerData>, value: any, choices: Array<any>, disabled?: boolean) {
    this.data = data;
    this.value = value;
    this.choices = choices;
    this.clickHandler = clickHandler;
    this.disabled = disabled;
  }
}
